/**
 * Pure display component for text blocks.
 * No editing UI. Safe to copy to frontend.
 */
export function TextView({ value, fontSize = 'medium', isMobile, mode, mobilePad = 'px-4' }) {
    if (!value || value.trim() === '')
        return null;
    const sizeClass = (mode === 'mobile' || isMobile)
        ? { small: 'text-xs', medium: 'text-sm', large: 'text-base' }[fontSize]
        : mode === 'tablet'
            ? { small: 'text-sm', medium: 'text-sm', large: 'text-base' }[fontSize]
            : { small: 'text-sm', medium: 'text-base', large: 'text-lg' }[fontSize];
    const padClass = (mode === 'mobile' || isMobile) ? mobilePad : '';
    return (<div className={`tpl-text-block rich-text-content mb-4 ${padClass} ${sizeClass} text-[#1B1A1E] leading-relaxed break-words`} dangerouslySetInnerHTML={{ __html: value }} />);
}
